export const LOAD_TABLE_FIELDS = {
  internal_id: 'internal_id',
  version_id: 'version_id',
  pred_roi: 'pred_roi',
  box_office_multiple: 'box_office_multiple',
  resulting_gross: 'resulting_gross',
  score: 'score',
  title: 'title',
  release_date: 'release_date',
  budget: 'budget',
  actors: 'actors',
  directors: 'directors',
  writers: 'writers',
  producers: 'producers',
  stars: 'stars',
  plot: 'plot',
  mpaa_rating: 'mpaa_rating',
  runtime: 'runtime',
  aspect_ratio: 'aspect_ratio',
  genres: 'genres',
  is_custom: 'is_custom',
  is_save_allowed: 'is_save_allowed',
}
